import * as React from 'react';
import styled from '@emotion/styled';
import { L } from '../../../../../lib/i18n';
import { Checkbox } from '../../../../../components/Checkbox/Checkbox';
import { MultiSelect } from '../../../../../components/Dropdown/MultiSelect';
import { AddonFilterProduct } from '@app/api/models/Orders';
import DropdownFlexContainer from './DropdownFlexContainer';

const Container = styled.div({ paddingRight: '10px', width: '200px' });

interface Props {
    filter: { product?: string[] };
    setFilter: (filter: any) => void;
    store: { products: AddonFilterProduct[]; loadAddonSuppliers(projectId?: string): Promise<void> };
}

export const FilteredProduct = (props: Props) => {
    const name = 'product';

    const handleOnChange = value => {
        event?.preventDefault();
        props.setFilter({
            ...props.filter,
            [name]: [...new Set<string>(value?.flatMap(id => id.value))]
        });
    };

    const options = props.store.products.map(v => ({
        value: v.name,
        label: (
            <DropdownFlexContainer>
                <Checkbox onChange={() => handleOnChange} checked={props.filter[name]?.includes(v.name) || false} />
                <span>{v.name}</span>
            </DropdownFlexContainer>
        )
    }));

    const selectAll = [
        {
            value: props.store.products?.map(product => product.name),
            label: ' Välj alla'
        },
        ...options
    ];

    return (
        <Container>
            <MultiSelect
                isMulti={true}
                isClearable
                value={props.filter[name]?.map(id => ({
                    value: id,
                    label: props.store.products.find(({ name: product_name }) => product_name === id)?.name
                }))}
                onChange={handleOnChange}
                name={name}
                label={L(name)}
                options={selectAll}
            />
        </Container>
    );
};
